const DEFAULT_BIKE_COLOR = 'blackblue';
const DEFAULT_IMAGE_SIZE = {
    WIDTH: 512,
    HEIGHT: 512
}
const BIKE_IMG_SOURCE = 'i';
const IMG_EXTENSION = '.jpg';
const START_IMG_INDEX = 5;
const ROTATE_360_FRAMES = 36;
const BIKE_TYPES = {
    ethos: 'ethos',
    premium: 'premium'
}
const BIKE_SPEED = {
    single: [
        { wheel: 16 },
        { wheel: 20, colors: ['aqua', 'red'] }
    ],
    geared: [
        { wheel: 24 }
    ]
}
const MAX_RIDER_HEIGHT = [
    { wheel: 16, max: { defaultHeight: 45 } },
    { wheel: 20, max: {[BIKE_TYPES.premium]: 52, defaultHeight: 50} }
]

export {
    DEFAULT_BIKE_COLOR,
    DEFAULT_IMAGE_SIZE,
    BIKE_IMG_SOURCE,
    IMG_EXTENSION,
    START_IMG_INDEX,
    ROTATE_360_FRAMES,
    BIKE_TYPES,
    BIKE_SPEED,
    MAX_RIDER_HEIGHT
}


// WEBPACK FOOTER //
// ./src/constants/bike.js